<template>
  <vx-card :title="title">
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vs-table
          search
          stripe
          border
          description
          :sst="true"
          :data="table.data"
          :max-items="table.length"
          :total="table.total"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
        >
          <template slot="header">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ table.start }} - {{ table.end }} of
                  {{ table.total }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in table.limits"
                  :key="item"
                  @click="handleChangelength(item)"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>

          <template slot="thead">
            <vs-th sort-key="batch_id">Batch ID</vs-th>
            <vs-th sort-key="total_request_records" class="text-center"
              >Total Request</vs-th
            >
            <vs-th sort-key="total_saved_records" class="text-center"
              >Total Saved</vs-th
            >
            <vs-th sort-key="status" class="text-center">Status</vs-th>
            <vs-th>Error Message</vs-th>
            <vs-th sort-key="created_at">Created At</vs-th>
            <vs-th class="text-center">Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <div class="flex items-center gap-2">
                  <!-- <feather-icon
                    icon="PackageIcon"
                    svgClasses="h-4 w-4 text-primary"
                  /> -->
                  <span class="font-semibold text-primary">{{
                    tr.batch_id
                  }}</span>
                </div>
              </vs-td>
              <vs-td class="text-center">
                <span class="badge-count badge-primary">{{
                  tr.total_request_records
                }}</span>
              </vs-td>
              <vs-td class="text-center">
                <span class="badge-count badge-success">{{
                  tr.total_saved_records
                }}</span>
              </vs-td>
              <vs-td class="text-center">
                <vs-chip
                  :color="getStatusColor(tr.status)"
                  class="font-semibold capitalize"
                >
                  {{ tr.status }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <span v-if="tr.error_message" class="text-danger text-sm">{{
                  tr.error_message
                }}</span>
                <span v-else class="text-grey text-sm">—</span>
              </vs-td>
              <vs-td>
                <div class="flex items-center gap-1 text-sm">
                  <feather-icon
                    icon="ClockIcon"
                    svgClasses="h-3 w-3 text-grey"
                  />
                  {{ formatDate(tr.created_at) }}
                </div>
              </vs-td>
              <vs-td class="text-center">
                <vs-button
                  size="small"
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-file-text"
                  @click="openHeaders(tr)"
                >
                  Show Headers
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <vs-pagination
          style="padding-top: 8px"
          :total="table.totalPage"
          v-model="setPage"
        />
      </div>
    </div>

    <vs-popup
      fullscreen
      :title="'Headers — ' + (selectedBatch ? selectedBatch.batch_id : '')"
      :active.sync="headerModal"
    >
      <div v-if="selectedBatch">
        <div class="batch-summary-bar mb-5">
          <div class="summary-item">
            <feather-icon icon="HashIcon" svgClasses="h-4 w-4" />
            <div>
              <p class="label">Batch ID</p>
              <p class="value text-primary">{{ selectedBatch.batch_id }}</p>
            </div>
          </div>
          <div class="summary-divider" />
          <div class="summary-item">
            <feather-icon icon="InboxIcon" svgClasses="h-4 w-4" />
            <div>
              <p class="label">Total Request</p>
              <p class="value">{{ selectedBatch.total_request_records }}</p>
            </div>
          </div>
          <div class="summary-divider" />
          <div class="summary-item">
            <feather-icon
              icon="CheckCircleIcon"
              svgClasses="h-4 w-4 text-success"
            />
            <div>
              <p class="label">Total Saved</p>
              <p class="value text-success">
                {{ selectedBatch.total_saved_records }}
              </p>
            </div>
          </div>
          <div class="summary-divider" />
          <div class="summary-item">
            <feather-icon icon="ActivityIcon" svgClasses="h-4 w-4" />
            <div>
              <p class="label">Status</p>
              <vs-chip
                :color="getStatusColor(selectedBatch.status)"
                class="mt-1 font-semibold capitalize"
              >
                {{ selectedBatch.status }}
              </vs-chip>
            </div>
          </div>
          <div class="summary-divider" />
          <div class="summary-item">
            <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" />
            <div>
              <p class="label">Created At</p>
              <p class="value">{{ formatDate(selectedBatch.created_at) }}</p>
            </div>
          </div>
        </div>

        <div class="headers-table-wrapper">
          <table class="nested-table">
            <thead>
              <tr>
                <th class="text-left">Inv Number</th>
                <th class="text-left">Billing Type</th>
                <th class="text-left">Dist ID</th>
                <th class="text-center">Salesman</th>
                <th class="text-left">Outlet</th>
                <th class="text-center">Inv Date</th>
                <th class="text-center">Posting Date</th>
                <th class="text-center">Status</th>
                <th class="text-center">Lines</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(hdr, hidx) in selectedBatch.headers">
                <tr
                  :key="'hdr-' + hidx"
                  :class="
                    expandedLines[hidx] ? 'header-row-active' : 'header-row'
                  "
                >
                  <td>
                    <span class="font-semibold text-dark">{{
                      hdr.inv_number
                    }}</span>
                  </td>
                  <td>
                    <span class="text-sm">{{ hdr.billing_type }}</span>
                  </td>
                  <td>{{ hdr.dist_id }}</td>
                  <td class="text-center">{{ hdr.salesman }}</td>
                  <td>
                    <span class="text-xs text-grey-dark font-mono">{{
                      hdr.outlet
                    }}</span>
                  </td>
                  <td class="text-center">
                    {{ formatDateShort(hdr.inv_date) }}
                  </td>
                  <td class="text-center">
                    {{ formatDateShort(hdr.posting_date) }}
                  </td>
                  <td class="text-center">
                    <vs-chip
                      :color="getStatusColor(hdr.status)"
                      class="font-semibold capitalize"
                    >
                      {{ hdr.status }}
                    </vs-chip>
                  </td>
                  <td class="text-center">
                    <button
                      class="lines-toggle-btn"
                      :class="
                        expandedLines[hidx] ? 'lines-toggle-btn--active' : ''
                      "
                      @click="toggleLines(hidx)"
                    >
                      <feather-icon
                        :icon="
                          expandedLines[hidx]
                            ? 'ChevronUpIcon'
                            : 'ChevronDownIcon'
                        "
                        svgClasses="h-3 w-3"
                      />
                      <span
                        >{{ expandedLines[hidx] ? "Hide" : "Show" }} Lines</span
                      >
                      <span class="lines-badge">{{
                        hdr.lines ? hdr.lines.length : 0
                      }}</span>
                    </button>
                  </td>
                </tr>

                <tr
                  v-if="expandedLines[hidx]"
                  :key="'lines-' + hidx"
                  class="lines-expand-row"
                >
                  <td colspan="9" class="p-0">
                    <div class="lines-panel">
                      <div class="lines-panel-header">
                        <feather-icon
                          icon="LayersIcon"
                          svgClasses="h-4 w-4 mr-2"
                        />
                        <span
                          >Lines for <strong>{{ hdr.inv_number }}</strong></span
                        >
                        <span class="ml-2 text-grey-dark text-sm"
                          >({{ hdr.lines ? hdr.lines.length : 0 }} items)</span
                        >
                      </div>
                      <table class="lines-table">
                        <thead>
                          <tr>
                            <th class="text-left">SKU Code</th>
                            <th class="text-right">Qty (Pcs)</th>
                            <th class="text-right">GSV</th>
                            <th class="text-right">Discount</th>
                            <th class="text-right">Tax</th>
                            <th class="text-right">Net</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(line, lidx) in hdr.lines"
                            :key="'line-' + lidx"
                            :class="
                              lidx % 2 === 0
                                ? 'lines-row-even'
                                : 'lines-row-odd'
                            "
                          >
                            <td>
                              <div class="flex items-center gap-2">
                                <feather-icon
                                  icon="BoxIcon"
                                  svgClasses="h-3 w-3 text-grey"
                                />
                                <span class="font-semibold font-mono">{{
                                  line.sku_code
                                }}</span>
                              </div>
                            </td>
                            <td class="text-right font-semibold">
                              {{ formatNumber(line.total_quantity_pcs) }}
                            </td>
                            <td class="text-right">
                              {{ formatCurrency(line.gsv) }}
                            </td>
                            <td class="text-right text-danger">
                              - {{ formatCurrency(line.discount) }}
                            </td>
                            <td class="text-right text-warning">
                              {{ formatCurrency(line.tax) }}
                            </td>
                            <td class="text-right text-success font-semibold">
                              {{ formatCurrency(line.net) }}
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="lines-footer">
                            <td class="font-semibold">Total</td>
                            <td class="text-right font-semibold">
                              {{
                                formatNumber(
                                  sumField(hdr.lines, "total_quantity_pcs")
                                )
                              }}
                            </td>
                            <td class="text-right font-semibold">
                              {{ formatCurrency(sumField(hdr.lines, "gsv")) }}
                            </td>
                            <td class="text-right font-semibold text-danger">
                              -
                              {{
                                formatCurrency(sumField(hdr.lines, "discount"))
                              }}
                            </td>
                            <td class="text-right font-semibold text-warning">
                              {{ formatCurrency(sumField(hdr.lines, "tax")) }}
                            </td>
                            <td class="text-right font-bold text-success">
                              {{ formatCurrency(sumField(hdr.lines, "net")) }}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      title: "Secondary Sales Logs",
      baseUrl: "/api/v1/secondary-sales",
      table: this.tableDefaultState(),
      headerModal: false,
      selectedBatch: null,
      expandedLines: {},
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "desc",
        sort: "id",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val === "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl, {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;
            this.setStartEnd();
          } else {
            this.$vs.notify({
              title: "Error",
              text: (resp && resp.message) || "Failed to load data.",
              color: "danger",
            });
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.error("getData error:", e);
          this.$vs.loading.close();
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) valStart = 1;
      if (this.table.total === 0) valStart = 0;
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) valEnd = this.table.total;
      if (this.table.totalSearch < this.table.total)
        valEnd = this.table.totalSearch;
      this.table.start = valStart;
      this.table.end = valEnd;
    },
    openHeaders(batch) {
      this.selectedBatch = batch;
      this.expandedLines = {};
      this.headerModal = true;
    },
    toggleLines(hidx) {
      this.$set(this.expandedLines, hidx, !this.expandedLines[hidx]);
    },
    getStatusColor(status) {
      const map = {
        completed: "success",
        saved: "success",
        failed: "danger",
        error: "danger",
        processing: "warning",
        pending: "warning",
      };
      return map[(status || "").toLowerCase()] || "primary";
    },
    formatDate(dateStr) {
      if (!dateStr) return "—";
      const d = new Date(dateStr);
      return d.toLocaleString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    formatDateShort(dateStr) {
      if (!dateStr) return "—";
      const d = new Date(dateStr);
      return d.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    formatCurrency(val) {
      if (val === null || val === undefined) return "—";
      return new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(val);
    },
    formatNumber(val) {
      if (val === null || val === undefined) return "—";
      return new Intl.NumberFormat("id-ID").format(val);
    },
    sumField(lines, field) {
      return lines.reduce((acc, l) => acc + (parseFloat(l[field]) || 0), 0);
    },
  },
  watch: {},
  mounted() {
    this.getData();
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>

<style scoped>
/* Badge counts */
.badge-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
  padding: 0 8px;
}
.badge-primary {
  background: rgba(var(--vs-primary), 0.12);
  color: rgba(var(--vs-primary), 1);
}
.badge-success {
  background: rgba(var(--vs-success), 0.12);
  color: rgba(var(--vs-success), 1);
}

/* Batch summary bar */
.batch-summary-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  background: #f8f9fb;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px 24px;
}
.summary-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 0 20px;
}
.summary-divider {
  width: 1px;
  height: 40px;
  background: #e2e8f0;
}
.summary-item .label {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
  margin: 0 0 2px 0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.summary-item .value {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #1e293b;
}

/* Headers table wrapper */
.headers-table-wrapper {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}
.nested-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.nested-table thead tr {
  background: linear-gradient(
    135deg,
    rgba(var(--vs-primary), 1) 0%,
    rgba(var(--vs-primary), 0.8) 100%
  );
}
.nested-table thead th {
  padding: 12px 14px;
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.header-row {
  background: #fff;
  transition: background 0.15s;
}
.header-row:hover {
  background: #f1f5f9;
}
.header-row-active {
  background: #eef6ff;
}
.nested-table tbody tr td {
  padding: 11px 14px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

/* Lines toggle button */
.lines-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1.5px solid #10b981;
  background: transparent;
  color: #10b981;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.lines-toggle-btn:hover,
.lines-toggle-btn--active {
  background: #10b981;
  color: #fff;
}
.lines-badge {
  border-radius: 10px;
  padding: 0 6px;
  font-size: 11px;
  font-weight: 700;
  min-width: 18px;
  text-align: center;
}
.lines-toggle-btn--active .lines-badge {
  background: rgba(255, 255, 255, 0.3);
}
.lines-toggle-btn:not(.lines-toggle-btn--active) .lines-badge {
  background: rgba(16, 185, 129, 0.15);
}

/* Lines expand panel */
.lines-panel {
  padding: 16px 20px 20px 40px;
  border-top: 2px solid #10b981;
}
.lines-panel-header {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: #065f46;
  margin-bottom: 12px;
}

/* Lines table */
.lines-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.lines-table thead tr {
  background: #065f46;
}
.lines-table thead th {
  padding: 9px 14px;
  color: #fff;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.lines-row-even {
  background: #fff;
}
.lines-row-odd {
  background: #f0fdf4;
}
.lines-table tbody td {
  padding: 9px 14px;
  border-bottom: 1px solid #e9f7f1;
  vertical-align: middle;
}
.lines-footer td {
  padding: 10px 14px;
  background: #d1fae5;
  border-top: 2px solid #10b981;
}

/* Core transitions */
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter,
.core-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
